export var AdvisoryDataKey;
(function (AdvisoryDataKey) {
    AdvisoryDataKey["OFFER_ABORTED"] = "offerAborted";
    AdvisoryDataKey["SPECIAL_REQUESTS_CONSIDERED"] = "specialRequestsConsidered";
    AdvisoryDataKey["DECISION_DOCUMENTATION"] = "decisionDocumentation";
    AdvisoryDataKey["PLACE_OF_TALK"] = "placeOfTalk";
    AdvisoryDataKey["DATE_OF_TALK"] = "dateOfTalk";
    AdvisoryDataKey["LENGTH_OF_TALK"] = "lengthOfTalk";
    AdvisoryDataKey["REASON_FOR_TALK"] = "reasonForTalk";
    AdvisoryDataKey["ATTENDES_OF_TALK"] = "attendesOfTalk";
    AdvisoryDataKey["ATTENDES_OF_TALK_AGENT_NAME"] = "attendesOfTalkagentName";
    AdvisoryDataKey["FINAL_ADVISORY_DECISION"] = "finalAdvisoryDecision";
})(AdvisoryDataKey || (AdvisoryDataKey = {}));
export var FinalAdvisoryDecision;
(function (FinalAdvisoryDecision) {
    FinalAdvisoryDecision["ADVISORY_MATCHES_DECISION"] = "advisoryMatchesDecision";
    FinalAdvisoryDecision["ADVISORY_DOESNT_MATCH_DECISION"] = "advisoryDoesntMatchDecision";
    FinalAdvisoryDecision["ADVISORY_DECLINED"] = "advisoryDeclined";
})(FinalAdvisoryDecision || (FinalAdvisoryDecision = {}));
export var FinalAdvisoryDecisionBinary;
(function (FinalAdvisoryDecisionBinary) {
    FinalAdvisoryDecisionBinary["ADVISORY_MATCHES_DECISION"] = "advisoryMatchesDecision";
    FinalAdvisoryDecisionBinary["ADVISORY_DECLINED"] = "advisoryDeclined";
})(FinalAdvisoryDecisionBinary || (FinalAdvisoryDecisionBinary = {}));
export var AdvisoryDataDuration;
(function (AdvisoryDataDuration) {
    AdvisoryDataDuration["MINS_15"] = "15 Minuten";
    AdvisoryDataDuration["MINS_30"] = "30 Minuten";
    AdvisoryDataDuration["MINS_60"] = "60 Minuten";
    AdvisoryDataDuration["MINS_90"] = "90 Minuten";
    AdvisoryDataDuration["MINS_120"] = "120 Minuten";
    AdvisoryDataDuration["MINS_150"] = "150 Minuten";
    AdvisoryDataDuration["MINS_180"] = "180 Minuten";
    AdvisoryDataDuration["MINS_210"] = "210 Minuten";
    AdvisoryDataDuration["MINS_240"] = "240 Minuten";
    AdvisoryDataDuration["MINS_270"] = "270 Minuten";
    AdvisoryDataDuration["MINS_300"] = "300 Minuten";
})(AdvisoryDataDuration || (AdvisoryDataDuration = {}));
